import Vue from 'vue'
import App from './App.vue'
import router from './router'

import utils from './utils/utils.js' //获取url参数
Vue.prototype.$utils = utils //注册全局方法

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
